<template>
    <section class="content">
        <div class="row">
            <div class="col-md-12">
                <microtags-form :microtag="microtag" :disabled="disabled" @activate-mod="activateMod()"
                              @click="updateMicrotag()"
                              :showLabels="true"></microtags-form>
            </div>
        </div>
    </section>
</template>

<script>
  import types from '../../store/mutation-types'
  import microtagsApi from '../../api/microtags'
  import microtagsForm from './Form.vue'

  export default {

    components: {
      microtagsForm
    },

    data () {
      return {
        microtag: false,
        disabled: true,
        interval: null
      }
    },

    beforeCreate () {
      microtagsApi.show(this.$route.params.id)
        .then((response) => {
          this.microtag = response
        })
    },

    created () {
      this.$store.commit(types.SET_HEADER_STATE, {
        pageTitle: 'Microtags inseriti',
        createButton: {
          display: true,
          text: 'Nuovo microtag',
          to: '/microtag'
        }
      })
      this.interval = setInterval(() => {
        if (!this.disabled) {
          microtagsApi.update(this.$route.params.id, this.microtag)
        }
      }, process.env.AUTOSAVE_TIMEOUT)
    },

    beforeDestroy () {
      clearInterval(this.interval)
    },

    methods: {
      activateMod () {
        this.disabled = !this.disabled
      },
      updateMicrotag () {
        this.loader = true
        return microtagsApi.update(this.$route.params.id, this.microtag)
          .then((response) => {
            toastr.success('Il microtag è stato salvato correttamente')
            this.loader = false
            this.disabled = true
          })
          .catch((response) => {
            this.loader = false
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/microtags/Show.vue